module.exports = __webpack_public_path__ + "static/media/devupkiet_logo.50c18567.jfif";